import { Component } from 'preact';

export default class HtmlRenderer extends Component {

	createMarkup(input) {
		const div = document.createElement('div');
		div.innerHTML = input;
		return div.childNodes.length === 0 ? '' : div.childNodes[0].nodeValue;
	}

	render({ html, ...props }) {
		return (
			// eslint-disable-next-line react/no-danger
			<div {...props} dangerouslySetInnerHTML={{ __html: this.createMarkup(html) }} />
		);
	}
}



// WEBPACK FOOTER //
// ./components/html/HtmlRenderer.js